import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.ports');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-page-admin-ports',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.ports/view.scss */
/* src/app/page.admin.ports/view.scss: no such file or directory */`],
})
export class PageAdminPortsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    public ports: any = [];
    public total: any;
    public dump: any = "10";
    public showAddModal: boolean = false;
    public newPort: any = {};

    public searchTerm = '';
    public pagenation: any = {
        page: 1,
        end: 1,
        start: 1,
    };

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        this.title.setTitle("포트 관리 - MY KREONET");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { page: this.pagenation.page, text: this.searchTerm, dump: this.dump });
        if (code != 200) return await this.service.alert.error("Error!");
        this.ports = data.rows;
        this.total = data.total;
        this.pagenation.start = Math.floor((this.pagenation.page - 1) / 10) * 10 + 1;;
        this.pagenation.end = data.lastpage;
        await this.service.render();
    }

    public async editPort(port: any) {
        const { code, data } = await wiz.call("editPort", port)
        if (code != 200) return await this.service.alert.error("Error!");
        await this.service.alert.success('저장되었습니다.');
    }

    public async addPort() {
        // if (!this.newPort.hostname || this.newPort.hostname == "") return await this.service.alert.error("hostname을 입력해주세요.");
        const requiredFields = [
            { key: 'hostname', label: 'hostname' },
            { key: 'ifName', label: 'ifName' },
            { key: 'ifAlias', label: 'ifAlias' }
        ];
        for (let field of requiredFields) {
            if (!this.newPort[field.key] || this.newPort[field.key].trim() === "") {
                return await this.service.alert.error(`${field.label}을(를) 입력해주세요.`);
            }
        }
        const { code, data } = await wiz.call("addPort", this.newPort)
        if (code == 200) {
            let res = await this.service.alert.success('새로운 장비가 추가되었습니다.')
            if (res) {
                this.showAddModal = false;
                await this.load();
            }
        }
    }

    public async removePort(port: any) {
        let res = await this.service.alert.warning("정말 삭제하시겠습니까?", "취소");
        if (res) {
            const { code, data } = await wiz.call("removePort", { portID : port });
            if (code != 200) return await this.service.alert.error("Error!");
            await this.service.alert.error("삭제되었습니다.");
            await this.load();
        }

    }

    public dumpChange(dump: string) {
        this.dump = dump;
        this.pagenation.page = 1;
        this.load();
    }

    private async pageLoad(p: number) {
        this.pagenation.page = p;
        await this.load();
    }
}

export default PageAdminPortsComponent;